import { createBaseThemeVariation } from './base';
export const TheOldStationNurseryTheme = createBaseThemeVariation({
    name: 'theoldstationnursery',
    brandColor: 'hsla(19, 72%, 55%, 1)',
    primaryColors: {
        p50: 'hsla(19, 72%, 98%, 1)',
        p75: 'hsla(19, 72%, 97%, 1)',
        p100: 'hsla(19, 72%, 96%, 1)',
        p200: 'hsla(19, 72%, 90%, 1)',
        p300: 'hsla(19, 72%, 70%, 1)',
        p400: 'hsla(19, 72%, 55%, 1)',
        p500: 'hsla(248, 39%, 35%, 1)',
    },
});
